import React from 'react'
import UploadCpd from '../../../features/cpd/CpdUpload/UploadCpd'

const cpdUpload = () => {
    return (
        <UploadCpd />
    )
}

export default cpdUpload